angular.module('Itao.IndicatorMap').directive('horizontalStackedBarChart', function (d3, mapConfig) {
    'use strict';

    var accessor = d3.hyperion.accessor;
    var compose = d3.hyperion.compose;
    var selectedIndicatorSets = [];
    var selectedIndicatorSet = 0;
    var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
    var colors = [];
    var color = d3.hyperion.indicatorColorAt;
    var sortedAccessor = function (d, i) {
        return i;
    };

    var combineData = function (layer, indicators, selectedIndicatorSet, districtLabelProperty) {
        var dataSet = [],
            districtStacks = {},
            differenceStacks = [],
            districtNames = [],
            setIndicators = selectedIndicatorSet.lists[0].indicators;

        // stack data
        angular.forEach(setIndicators, function (indicator, i) {
            var districtData = [];
            for (var districtUid in layer.districts) {
                if (layer.hasOwnProperty(districtUid) && selectedIndicatorSet) {
                    var districtKey = layer.districts[districtUid][districtLabelProperty];
                    districtNames.push(districtKey);
                    var data = {
                        y: +layer[districtUid][indicator.uid],
                        x: districtKey,
                        name: layer.districts[districtUid].name,
                        indicator: indicator.name,
                        prefix: indicator.prefix,
                        indicatorKey: indicator.key
                    };
                }
                districtData.push(data);
                if (i < setIndicators.length / 2) {
                    if (!districtStacks[districtUid]) districtStacks[districtUid] = 0;
                    districtStacks[districtUid] += layer[districtUid][indicator.uid];
                }
            }
            dataSet.push(districtData);
        });
        // get Max-Value
        districtStacks = Object.keys(districtStacks).map(function (key) {
            return districtStacks[key];
        });
        var maxValue = Math.max.apply(null, districtStacks);

        var marginData = [];
        angular.forEach(districtStacks, function (value, index) {
            differenceStacks.push(maxValue - value);
            marginData.push({
                y: (maxValue - value),
                x: districtNames[index]
            });
        });
        dataSet.unshift(marginData);
        return d3.layout.stack()(dataSet);
    };

    /**
     * Creates the Color-Array Set-Bars
     * @param numberOfIndicators
     * @returns {Array}
     */
    var buildColorArray = function (numberOfIndicators) {
        var numberOfColors = Math.ceil((numberOfIndicators) / 2),
            configColors = mapConfig.styling.default.complexColorSet,
            colors = [];

        for (var i = 0; i < numberOfIndicators; i++) {
            if (i < numberOfColors) {
                colors.push(configColors[i]);
            } else {
                colors.push(configColors[numberOfIndicators - (i + 1)]);
            }
        }
        colors.unshift('rgba(0,0,0,0)');
        return colors;
    };

    var calculateMaxValue = function (data) {
        return d3.max(data[data.length - 1].map(function (current) {
            return current.y + current.y0;
        }));
    };

    var calculateMinValue = function (data) {
        return d3.min(data[data.length - 1].map(function (current) {
            return current.y + current.y0;
        }));
    };

    var horizontalStackedBarChart = function () {
        var indicators = [],
            svgHeight = 200,
            margin = {top: 20, right: 40, bottom: 20, left: 50},
            duration = 400,
            numberFormat = germanNumberFormat(',.'+mapConfig.relativeIndicatorsDecimalPlaces+'f'),
            tip;

        var chart = function (selection) {
            selection.each(function (data) {
                // calculate min and max values and check that 0 is included
                var minValue = calculateMinValue(data);
                var maxValue = calculateMaxValue(data);
                if (minValue > 0) {
                    minValue = 0;
                }
                if (maxValue < 0) {
                    maxValue = 0;
                }

                var keyDigits = d3.max(data[0].map(function (d) {
                    return accessor('x')(d).length;
                }));
                margin.left = 10 + 13 * keyDigits;

                // Invert the x and y values, and y0 becomes x0 --> Horizontal-Stack
                data = data.map(function (group) {
                    return group.map(function (d) {
                        return {
                            x: d.y,
                            y: d.x,
                            x0: d.y0,
                            name: d.name,
                            indicator: d.indicator,
                            indicatorKey: d.indicatorKey
                        };
                    });
                });

                var container = d3.select(this).datum([data]).classed('horizontal-stacked-bar-chart', true);
                var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

                var width = svgWidth - margin.left - margin.right,
                    height = svgHeight - margin.top - margin.bottom;

                if (angular.isDefined(tip)) {
                    tip.destroy();
                }

                tip = d3.tip()
                    .attr('class', 'd3-tip')
                    .offset(function () {
                        return [-5, 0];
                    })
                    .html(function (d, indicatorNumber, districtNumber) {
                        var value = d.prefix + numberFormat(d.x) + " %";
                        return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + d.name + ' (' + d.y + ')</b><br><span style="color:#000000;">' + d.indicator.replace('<br/>', '').replace('<br>','').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
                    });

                var svg = container.selectAll('svg').data([data]);
                var svgEnter = svg.enter()
                    .append('svg')
                    .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

                var stack = svg.selectAll('.stack').data([data]);
                var stackEnter = stack.enter().append('g')
                    .attr('class', 'stack')
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');


                stack.transition().duration(duration)
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
                    .attr('height', svgHeight)
                    .attr('width', svgWidth); // set viewBox of the svg

                var g = stack.selectAll('g').data(data);

                var xScale = d3.scale.linear()
                        .range([0, width])
                        .domain([minValue, maxValue])
                        .nice(),
                    districts = data[0].map(function (d) {
                        return d.y;
                    }),
                    yScale = d3.scale.ordinal()
                        .rangeRoundBands([0, height], .1)
                        .domain(districts),
                    xAxis = d3.svg.axis()
                        .scale(xScale)
                        .orient('bottom'),
                    yAxis = d3.svg.axis()
                        .scale(yScale)
                        .orient('left');

                g.call(d3.hyperion.addVerticalHighlightLines(mapConfig.redLines, x, height, duration));

                var gEnter = g.enter()
                    .append('g')
                    .style('fill', function (d, i) {
                        return colors[i];
                    })
                    .attr('class', 'margin-group');

                // xAxis
                stackEnter.append('g')
                    .attr('class', 'x axis')
                    .attr('transform', 'translate(0,' + height + ')');

                stack.select('.x.axis')
                    .transition().duration(duration)
                    .attr('transform', 'translate(0,' + height + ')')
                    .attr('fill', '#000000')
                    .call(xAxis);

                // yAxis
                stackEnter.append('g')
                    .attr('class', 'y axis');

                stack.select('.y.axis')
                    .transition().duration(duration)
                    .attr('fill', '#000000')
                    .call(yAxis);

                // vertical Middle-Line
                var middleLineAt = data[Math.ceil(((data.length - 1) / 2)) + 1][0]['x0'];
                stackEnter.append('line')
                    .attr('class', 'middle-line');

                stack.select('.middle-line')
                    .transition().duration(duration)
                    .attr('x1', xScale(middleLineAt))
                    .attr('x2', xScale(middleLineAt))
                    .attr('y1', 0)
                    .attr('y2', height)
                    .attr("stroke-width", 1);

                // draw new bars
                var bars = g.selectAll('rect')
                    .data(function (d) {
                        return d;
                    });

                bars
                    .enter()
                    .append('rect')
                    .attr('height', yScale.rangeBand())
                    .attr('y', function (d, i) {
                        return yScale(d.y);
                    })
                    .attr('x', xScale(0))
                    .attr('width', 0);

                bars
                    .transition().duration(duration)
                    .attr('x', function (d) {
                        return xScale(d.x0);
                    })
                    .attr('y', function (d, i) {
                        return yScale(d.y);
                    })
                    .attr('height', yScale.rangeBand())
                    .attr('width', function (d) {
                        return xScale(d.x);
                    });

                // add tooltips to bars
                bars.call(tip);
                bars.on('mouseover', tip.show)
                    .on('mouseout', tip.hide);

                // remove unused bars
                bars.exit().transition().duration(duration)
                    .attr('width', 0)
                    .attr('height', 0)
                    .remove();
            });
        };

        /**
         * getter/setter for indicators
         * @param {Array} [newIndicators] set of new indicators
         * @returns {*}
         */
        chart.indicators = function (newIndicators) {
            if (!arguments.length) {
                return indicators;
            } else {
                indicators = newIndicators;
                return chart;
            }
        };

        /**
         * getter/setter for svgHeight
         * @param {int} [newHeight] height of the diagram
         * @returns {*}
         */
        chart.height = function (newHeight) {
            if (!arguments.length) {
                return svgHeight;
            } else {
                svgHeight = newHeight;
                return chart;
            }
        };

        /**
         *
         * @returns {*}
         */
        chart.tip = function () {
            return tip;
        };

        return chart;
    };

    /**
     * @param {HTMLElement} element the chart element
     * @returns {number}
     */
    var calculateChartHeight = function (element) {
        var content = element.closest('.grid-stack-item-content-horizontalStackedBarChart');
        return content.height() - jQuery(content).find('.selected-indicator-set').height() - 10;
    };

    return {
        restrict: 'E',
        templateUrl: mapConfig.templateBasePath + 'horizontalStackedBarChart.html',
        scope: {
            layer: '=',
            indicators: '=',
            indicatorSets: '=',
            dimensionX: '@',
            dimensionY: '@',
            mouseOverFeature: '=',
            config: '='
        },
        link: function (scope, element) {
            scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
            scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
            scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
            scope.config.fullscreen = scope.config.fullscreen || false;

            scope.setSelectedIndicatorSet = function (indicatorSet) {
                if (indicatorSet.lists[0].indicators.length !== scope.config.selectedIndicatorSet.lists[0].indicators.length) {
                    d3.select(element[0]).select('svg').remove();
                }
                scope.config.selectedIndicatorSet = scope.indicatorSetToShow;
            };

            var horizontalStackedBarChartFunction = horizontalStackedBarChart();

            /**
             * update the chart from one of the watchers
             *
             * @param {*} watcherNewValue new value of the watcher
             * @param {*} watcherOldValue old value of the watcher
             * @param {*} watcherScope new scope from the watcher
             * @param {Number} newHeight the height for the svg
             */
            var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
                if (newHeight == null) {
                    newHeight = calculateChartHeight(element);
                }

                var indicators = scope.indicators;
                scope.selectedIndicatorSets = [];

                angular.forEach(indicators, function (indicator) {
                    if (indicator.isDefault) {
                        angular.forEach(scope.indicatorSets, function (indicatorSet) {
                            if (indicatorSet.defaultIndicator.uid === indicator.uid && scope.selectedIndicatorSets.indexOf(indicatorSet) < 0) {
                                scope.selectedIndicatorSets.push(indicatorSet);
                            }
                        });
                    }
                });

                if (scope.selectedIndicatorSets.length) {
                    scope.indicatorSetToShow = scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet ? scope.config.selectedIndicatorSet : scope.selectedIndicatorSets[0];

                    var data = combineData(scope.layer, indicators, scope.indicatorSetToShow, scope.config.districtLabelProperty);
                    colors = buildColorArray(data.length - 1);
                    horizontalStackedBarChartFunction
                        .indicators(indicators)
                        .height(newHeight);

                    d3.select(element.find('.widget-inner:first')[0])
                        .data([data])
                        .call(horizontalStackedBarChartFunction);
                } else {
                    d3.select(element[0]).select('svg').remove();
                }
            };

            jQuery(document).on("fullscreen", rerender);

            var layerWatcher = scope.$watchCollection('layer', rerender);
            var indicatorWatcher = scope.$watchCollection('indicators', rerender);
            var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
            var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
            var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
            var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
            var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

            var legendHeightWatcher = scope.$watch(function () {
                return calculateChartHeight(element);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && newValue > 0) {
                    rerender(newValue, oldValue, null, newValue);
                }
            });

            // remove watcher on destroy
            element.on('$destroy', function () {
                layerWatcher();
                indicatorWatcher();
                indicatorSetWatcher();
                dimensionWatcher();
                legendHeightWatcher();
                selectedIndicatorSet();
                districtLabelPropertyWatcher();
                fullscreenWatcher();
                // remove tooltip dom element
                if (angular.isDefined(horizontalStackedBarChartFunction.tip())) {
                    horizontalStackedBarChartFunction.tip().destroy();
                }
            });
        }
    };
});
